export default __webpack_public_path__ + "static/media/growforfree.0ce18318.png";